// @flow
import { ensureArray } from '@zapier/common-utils';

const partialWithDefault = (
  fn: Function,
  outerArgs: any[] = [],
  defaultValue?: any
) => (...innerArgs: any[]) => {
  const result = fn(...ensureArray(outerArgs), ...innerArgs);
  return result === undefined || result === null ? defaultValue : result;
};

export default partialWithDefault;
